export const Footer = () => {
  return (
    <div className="Footer">
      Have an idea for a feature or found a bug? Report it to{" "}
      <a href="mailto:chris@chriswhitney.com">chris@chriswhitney.com</a>
    </div>
  );
};
